import React from 'react';
import EmailConnectionTest from '../components/email/EmailConnectionTest';

/**
 * Email Service Test Page
 * Test page for Step 3: Database Service Layer
 */
const EmailServiceTest = () => {
  return (
    <div className="min-h-screen bg-gray-100">
      <EmailConnectionTest />
    </div>
  );
};

export default EmailServiceTest;
